import React, { createContext } from "react";

const initialState = {
    authState: {
        userName: '',
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        roleID: '',
        roles: [],
    },
    authActions: {
        setUserName: (input) => { },
        setTitle: (input) => { },
        setFirstName: (input) => { },
        setLastName: (input) => { },
        setEmail: (input) => { },
        setRoleID: (input) => { },
        setRoles: (input) => { },
    }
};

const CustomContext = createContext(initialState);
export const CounterContext = React.createContext();
export default CustomContext;